import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { TabularService } from "projects/sepidz-web-framework-shell/src/lib/tabular/tabular.service ";
import { form_control } from "projects/sepidz-web-framework/src/lib/models";
import { FormControlTypes } from "projects/sepidz-web-framework/src/lib/models/form-base-control.model";
@Component({
  selector: "ngx-cheque-book-info-form",
  templateUrl: "./cheque-book-info-form.component.html",
  styleUrls: ["./cheque-book-info-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChequeBookInfoFormComponent extends BaseFormComponent<any> {
  @Input() ChequeBookDescription: string;
  constructor(_tabsservice: TabularService, protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
    this.tabsservice = _tabsservice;
  }
  async ngOnInit() {
    this.label = "چاپ چک";
    this.setdefault();
  }
  setdefault() {
    this.model = {};
    this.model["HasDateToLeter"] = true;
    this.model["HasRemitted"] = false;
    this.model["HasAdditionalDescription"] = false;
    this.model["ChequeBookDescription"] = this.ChequeBookDescription;
    this.model["AdditionalDescription"] = "بدون خط خوردگی";
    this.orignalColumns = [];
    this.orignalColumns.push(<form_control>{
      label: "تاریخ به حروف",
      controlType: FormControlTypes.checkbox,
      modelName: "HasDateToLeter",
      disabled: false,
      name: "HasDateToLeter",
      order: 0,
      textType: "text",
      userClass: "select-shr",
      columnNumber: 1,
      isFloat: 1,
      formVisible: true,
      listVisible: true,
      required: false,
    });
    this.orignalColumns.push(<form_control>{
      label: "حواله کرد",
      controlType: FormControlTypes.checkbox,
      modelName: "HasRemitted",
      disabled: false,
      name: "HasRemitted",
      order: 1,
      textType: "text",
      userClass: "select-shr",
      columnNumber: 1,
      isFloat: 1,
      formVisible: true,
      listVisible: true,
      required: false,
    });
    this.orignalColumns.push(<form_control>{
      label: "شرح تکمیلی",
      controlType: FormControlTypes.checkbox,
      modelName: "HasAdditionalDescription",
      disabled: false,
      name: "HasAdditionalDescription",
      order: 2,
      textType: "text",
      columnNumber: 1,
      userClass: "select-shr",
      formVisible: true,
      listVisible: true,
      required: false,
    });
    this.orignalColumns.push(<form_control>{
      label: "شرح چک",
      controlType: FormControlTypes.textbox,
      modelName: "ChequeBookDescription",
      disabled: false,
      name: "ChequeBookDescription",
      order: 3,
      textType: "text",
      userClass: "select-md",
      columnNumber: 1,
      formVisible: true,
      listVisible: true,
      required: false,
    });
    this.orignalColumns.push(<form_control>{
      label: "شرح تکمیلی",
      controlType: FormControlTypes.textbox,
      modelName: "AdditionalDescription",
      disabled: false,
      name: "AdditionalDescription",
      order: 4,
      textType: "text",
      userClass: "select-md",
      columnNumber: 1,
      formVisible: true,
      listVisible: true,
      required: false,
    });
    this.columns = this.orignalColumns;
    this.setFormGroup(this.model);
  }
  public async save() {
    this.result = this.getDataFromFormGroup();
    this.close();
  }
}
